<template>
    <time
        :datetime="datetime"
        :title="formattedDateTime"
        v-text="formattedDate">
    </time>
</template>

<script>

const monthShortNames = [
    'Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'
];

function zeroPad(value, places) {
    let digits = value.toString().split('');
    while(digits.length < places) {
        digits.unshift(0);
    }
    return digits.join('');
}

export default {
    props: {
        'datetime': {
            type: String,
            default: ''
        }
    },

    computed: {
        formattedDate() {
            let d;
            if (this.datetime) {
                d = new Date(this.datetime);
                // Jan 12, 2018
                return monthShortNames[d.getMonth()]
                    + ' '
                    + d.getDate()
                    + ', '
                    + d.getFullYear()
            } else {
                return '';
            }
        },

        formattedTime() {
            let d;
            if (this.datetime) {
                d = new Date(this.datetime);
                // 12:32pm
                return d.getHours()%12
                    + ':'
                    + zeroPad(d.getMinutes(),2)
                    + ((d.getHours() < 12) ? 'am' : 'pm');
            } else {
                return '';
            }
        },

        formattedDateTime() {
            if (this.datetime) {
                return this.formattedDate + ' at ' + this.formattedTime;
            } else {
                return '';
            }
        }
    }
}
</script>




// WEBPACK FOOTER //
// resources/assets/js/components/TimeStamp.vue